export default __webpack_public_path__ + "static/media/pic32.7c804f83.png";